import React, { useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { MDBox } from '../../MDBox';
import {
  useMaterialUIController,
  setLayout,
} from '../../../contexts/layoutContext';

interface PageLayoutProps {
  background: 'white' | 'light' | 'default';
  children: ReactNode;
}

function PageLayout({ background = 'default', children }: PageLayoutProps) {
  const [, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, 'page');
  }, [pathname, dispatch]);

  return (
    <MDBox
      width="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ overflowX: 'hidden' }}
    >
      {children}
    </MDBox>
  );
}

export { PageLayout };
